export default "<div class=\"content\" [innerHTML]=\"html\"></div>\r\n";